import PropTypes from 'prop-types';
// components
import MainLayout from './main';
import DefaultLayout from './DefaultLayout';
import NavLayout from './nav';
import PayLayout from './pay';

// ----------------------------------------------------------------------

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['main', 'default', 'nav', 'instant', 'pay']),
};

export default function Layout({ variant = 'default', children }) {

  if (variant === 'main') {
    return <MainLayout> {children} </MainLayout>;
  }
  else if (variant === "nav") {
    return <NavLayout> {children} </NavLayout>;
  }
  else if (variant === "pay") {
    return <PayLayout> {children} </PayLayout>;
  }
  else {
    return <DefaultLayout> {children} </DefaultLayout>;
  }
}
